import { Alert } from "@productlane/ui"

import { useTrial } from "@/lib/useTrial"
import { SettingsContainer } from "@/screens/settings/settings-switches/settings-container"
import { SettingsHeader } from "../../settings-header"
import { ImportPortalBadge } from "../import-portal"
import { MarkdownUploadField } from "./steps/markdown-upload-field"
import { SiteImportField } from "./steps/site-import-field"

export function DocsMarkdownImportPage() {
	const { hasTrialEnded } = useTrial()

	return (
		<>
			<SettingsHeader
				title="Markdown import"
				subtitle="Read an existing help center from its URL, or upload markdown files."
				titleSuffix={<ImportPortalBadge />}
			/>
			{!hasTrialEnded ? (
				<SettingsContainer>
					<SiteImportField />
					<MarkdownUploadField />
				</SettingsContainer>
			) : (
				<Alert variant="warning">Trial ended. Upgrade to import data.</Alert>
			)}
		</>
	)
}
